<div class="st-drawer-wrapper">
  <a href=""></a>
  <div class="st-drawer-header">
    <span class="text-header-16 text-semibold">Añadir proyecto</span>
    <app-st-icon (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
  </div>

  <form class="st-drawer-content st-form" nz-form [formGroup]="projectForm">
    <!-- Nombre del Proyecto (Requerido) -->
    <nz-form-item>
      <nz-form-label [nzSpan]="24" nzRequired>Nombre del proyecto</nz-form-label>
      <nz-form-control [nzErrorTip]="'Este campo es requerido'" nzHasFeedback>
        <input type="text" nzSize="large" nz-input formControlName="name"
               placeholder="Introduce el Nombre del proyecto..."/>
      </nz-form-control>
    </nz-form-item>

    <!-- ID de la Presupuesto en Odoo -->
    <!-- <nz-form-item>
      <nz-form-label [nzSpan]="24">ID de la Presupuesto en Odoo</nz-form-label>
      <nz-form-control>
        <input type="number" nzSize="large" nz-input formControlName="cotizacion"
               placeholder="Introduce el ID del presupuesto en Odoo..."/>
      </nz-form-control>
    </nz-form-item> -->

    <div nz-row [nzGutter]="16">
      <!-- Cliente -->
      <!-- <div nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>Cliente</nz-form-label>
          <nz-form-control [nzErrorTip]="'Este campo es requerido'" nzHasFeedback>
            <app-avatar-select
              formControlName="cliente"
              [options]="clientsList"
              placeholder="Selecciona el Cliente..."
            ></app-avatar-select>
          </nz-form-control>
        </nz-form-item>
      </div> -->

      <!-- Ejecutivo de Operaciones -->
      <div nz-col [nzXs]="24" [nzSm]="12">
<!--        <nz-form-item>-->
<!--          <nz-form-label [nzSpan]="24">Ejecutivo de operaciones</nz-form-label>-->
<!--          <nz-form-control>-->
<!--            <app-avatar-select-->
<!--              formControlName="ejecutivoOperaciones"-->
<!--              [options]="cecEmployeeList"-->
<!--              placeholder="Selecciona el Ejecutivo de Operaciones..."-->
<!--            ></app-avatar-select>-->
<!--          </nz-form-control>-->
<!--        </nz-form-item>-->
        <!-- <nz-form-item>
          <nz-form-label [nzSpan]="24">Ejecutivo Comercial</nz-form-label>
          <nz-form-control>
            <app-avatar-select
              formControlName="ejecutivoComercial"
              [options]="cecEmployeeList"
              placeholder="Selecciona el Ejecutivo Comercial...">
            </app-avatar-select>
          </nz-form-control>
        </nz-form-item> -->
      </div>
    </div>


    <div nz-row [nzGutter]="16">
      <!-- Gerente Administración -->
      <div nz-col [nzXs]="24" [nzSm]="12">
<!--        <nz-form-item>-->
<!--          <nz-form-label [nzSpan]="24">Gerente Administración</nz-form-label>-->
<!--          <nz-form-control>-->
<!--            <app-avatar-select-->
<!--              formControlName="gerenteAdministracion"-->
<!--              [options]="cecEmployeeList"-->
<!--              placeholder="Selecciona el Gerente Administración...">-->
<!--            </app-avatar-select>-->
<!--          </nz-form-control>-->
<!--        </nz-form-item>-->
      </div>

      <!-- Subgerente Proyectos -->
<!--      <div nz-col [nzXs]="24" [nzSm]="12">-->
<!--        <nz-form-item>-->
<!--          <nz-form-label [nzSpan]="24">Subgerente Proyectos</nz-form-label>-->
<!--          <nz-form-control>-->
<!--            <app-avatar-select-->
<!--              formControlName="subgerenteProyectos"-->
<!--              [options]="cecEmployeeList"-->
<!--              placeholder="Selecciona el Subgerente Proyectos...">-->
<!--            </app-avatar-select>-->
<!--          </nz-form-control>-->
<!--        </nz-form-item>-->
<!--      </div>-->

      <!-- Ejecutivo Comercial -->
<!--      <div nz-col [nzXs]="24" [nzSm]="12">-->
<!--        -->
<!--      </div>-->

      <!-- Gerente de Operaciones -->
      <div nz-col [nzXs]="24" [nzSm]="12">
<!--        <nz-form-item>-->
<!--          <nz-form-label [nzSpan]="24">Jefe de Operaciones</nz-form-label>-->
<!--          <nz-form-control>-->
<!--            <app-avatar-select-->
<!--              formControlName="gerenteOperaciones"-->
<!--              [options]="cecEmployeeList"-->
<!--              placeholder="Selecciona el Jefe de Operaciones...">-->
<!--            </app-avatar-select>-->
<!--          </nz-form-control>-->
<!--        </nz-form-item>-->
      </div>
    </div>
    <div nz-row [nzGutter]="16">
      <!-- Fecha Inicio -->
      <div nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Fecha Inicio</nz-form-label>
          <nz-form-control>
            <nz-input-group nzSize="large" class="addon-after" [nzAddOnAfter]="suffixTmpl">
              <nz-date-picker nzSize="large" [nzSuffixIcon]="emtySuffixTmpl" class="w-100" formControlName="date"
                              nzPlaceHolder="Introduce Fecha inicio..." nzFormat="dd-MM-yyyy"
                              [nzDisabledDate]="disabledStartDate(projectForm.get('endDate')?.value)"></nz-date-picker>
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Fecha Fin -->
      <div nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Fecha Fin</nz-form-label>
          <nz-form-control>
            <nz-input-group nzSize="large" class="addon-after" [nzAddOnAfter]="suffixTmpl">
              <nz-date-picker nzSize="large" [nzSuffixIcon]="emtySuffixTmpl" class="w-100" formControlName="endDate"
                              nzPlaceHolder="Introduce Fecha fin..." nzFormat="dd-MM-yyyy"
                              [nzDisabledDate]="disabledEndDate(projectForm.get('date')?.value)"></nz-date-picker>
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </form>

  <div class="st-drawer-footer">
    <button (click)="close()" class="text-btn-14" nz-button nzType="text" nzShape="round" nzSize="large">Cancelar
    </button>
    <button (click)="createProject()" [disabled]="!projectForm.valid"
            class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
      <app-st-icon *ngIf="!creatingProject" class="prefix" [name]="'add'" [bold]="true"></app-st-icon>
      <app-st-icon *ngIf="creatingProject" class="prefix" [name]="'progress_activity'" [bold]="true"></app-st-icon>
      <span>Añadir proyecto</span>
    </button>
  </div>
</div>


<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>
<ng-template #customClearIcon>
  <app-st-icon class="custom-clear" name="close"></app-st-icon>
</ng-template>

<ng-template #suffixTmpl>
  <app-st-icon style="font-size: 20px" color="#666666" [bold]="true" name="calendar_today"></app-st-icon>
</ng-template>
<ng-template #emtySuffixTmpl>
</ng-template>

<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
             [showUndo]="toastConfig.showUndo"
             [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
</ng-template>
